// Store global pra estado de UI compartilhado entre componentes
// (sem prop-drilling). Hoje so tem activeLobbyTab — topbar precisa
// renderizar tabs Torneios/Ranking e Lobby precisa saber qual ta
// ativa pra renderizar conteudo.
import { writable } from 'svelte/store';

export type LobbyTab = 'torneios' | 'ranking';

export const activeLobbyTab = writable<LobbyTab>('torneios');

// loginModalOpen: o app e navegavel SEM login (mostra campeonatos pra
// todos). O modal de login/registro so abre on-demand: ao clicar
// "ENTRAR" no topo OU ao tentar se inscrever num torneio sem estar
// logado. Felipe 2026-06-01.
export const loginModalOpen = writable(false);

// openLogin abre o modal de auth. opcional: aba inicial (login/registro).
export function openLogin() {
  loginModalOpen.set(true);
}
